import instanceAxios from '../config/api'
import { calculateCriticalRiskRatioType, calculateShortTermCriticalRiskRatioType, calculateShortTermRiskRatioType, countRisksByCriticalityType, getSecurityControlsByPlanType, Plan, PlanResponse } from '../types/planTypes'
const API_URL = '/plans'

export const getAllPlans = async ({
  page,
  pageSize,
  search
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<PlanResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Plan.')
  }
}
export const deletePlanApi = async (PlanId: string) => {
  try {
    const response = await instanceAxios.delete<Plan[]>(`${API_URL}/` + PlanId)
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch plans.')
  }
}

export const addPlanApi = async (newPlan: Plan): Promise<Plan> => {
  try {
    const response = await instanceAxios.post<Plan>(`${API_URL}`, newPlan)
    return response.data
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to add Plan.')
  }
}

export const getPlanbyIdApi = async (PlanId: string) => {
  try {
    const response = await instanceAxios.get<Plan>(`${API_URL}/` + PlanId)
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetchPlan.')
  }
}

export const updatePlanApi = async (
  updatePlan: Plan,
  _id: string
): Promise<Plan> => {
  try {
    const response = await instanceAxios.put<Plan>(
      `${API_URL}/${_id}`,
      updatePlan
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUTPlan.')
  }
}



export const getPlansByMissionIdApi = async (MissionId: string, page?: number, pageSize?: number) => {
  try {
    const response = await instanceAxios.get<PlanResponse>(
      `missions/getPlans/${MissionId}?page=${page || 1}&pageSize=${pageSize || 10}`
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch Plans.');
  }
};










export const calculateCriticalRiskRatioApi = async (
  idPlan: string
): Promise<calculateCriticalRiskRatioType> => {
  try {
    const response =
      await instanceAxios.get<calculateCriticalRiskRatioType>(
        `plans/calculateCriticalRiskRatio/${idPlan}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Risk Ratio')
  }
}


export const calculateShortTermCriticalRiskRatioApi = async (
  idPlan: string
): Promise<calculateShortTermCriticalRiskRatioType> => {
  try {
    const response =
      await instanceAxios.get<calculateShortTermCriticalRiskRatioType>(
        `plans/calculateShortTermCriticalRiskRatio/${idPlan}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Risk Ratio')
  }
}


export const calculateShortTermRiskRatioApi = async (
  idPlan: string
): Promise<calculateShortTermRiskRatioType> => {
  try {
    const response =
      await instanceAxios.get<calculateShortTermRiskRatioType>(
        `plans/calculateShortTermRiskRatio/${idPlan}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Risk Ratio')
  }
}


export const countRisksByCriticalityApi = async (
  idPlan: string
): Promise<countRisksByCriticalityType> => {
  try {
    const response =
      await instanceAxios.get<countRisksByCriticalityType>(
        `plans/countRisksByCriticality/${idPlan}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count Critical Risk Ratio')
  }
}

export const getSecurityControlsByPlanApi = async (
  idPlan: string
): Promise<getSecurityControlsByPlanType> => {
  try {
    const response =
      await instanceAxios.get<getSecurityControlsByPlanType>(
        `plans/getSecurityControlsByPlan/${idPlan}`
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to count get Security Controls ByPlan')
  }
}